/**
 * Created by jv on 15/05/2018.
 */
export { default as Loader } from "./loader";
export { default as Menu } from "./menu";
export { default as Game } from "./game";
export { default as Scoreboard } from "./scoreboard";
export { default as GameOver } from "./game-over";
export { default as Coop } from "./coop";



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/index.js